module.exports = __webpack_public_path__ + "static/chancellor-merkel-it-summit-ball-cameral.d046a997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ballcamera/img/chancellor-merkel-it-summit-ball-cameral.jpg
// module id = 429
// module chunks = 255389747514053